<template>
  <div class="componentRoot">
    <v-card flat class="">
      <v-container fluid>
        <v-row>
          <v-col>
            <h2>{{ $t("routes.bills") }}</h2>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-card flat class="mt-2">
      <v-container fluid>
        <v-row v-if="documents && documents.bills && documents.bills.length > 0">
          <v-col :cols="documentCols" v-for="bill in documents.bills">
            <v-card flat class="background-background" @click="getBillFile($event, bill, true)">
              <v-container fluid>
                <v-row>
                  <v-col>
                    {{ $t("basics.bill") }} {{ $t("constants.month_" + (getMonth(bill).month - 1)) }}
                    {{ getMonth(bill).year }}
                  </v-col>
                  <v-spacer />
                  <v-col cols="auto">
                    <v-icon color="primary">mdi-download</v-icon>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>

        <v-row v-else>
          <v-col>
            {{ $t("messages.noItems") }}
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>

export default {
  name: "profileDocumentsView",

  data() {
    return {
      documents: undefined
    };
  },

  computed: {
    documentCols() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 12;
        case "sm":
          return 12;
        case "md":
          return 6;
        case "lg":
          return 4;
        case "xl":
          return 3;
        case "xxl":
          return 3;
        default:
          return 3;
      }
    },
  },

  methods: {    
    openFile(bill, newTab) {
      console.log(bill, newTab)
      if (newTab) {
        window.open(bill.blob, "_blank");
      } else {
        const a = document.createElement("a");
        console.log(bill)
        a.href = bill.blob;
        a.download = bill.filename;
        document.body.appendChild(a);
        a.click();
      }
    },
    getMonth(bill){
      let temp = bill.billing_number.split("-")[1]

      let year = temp.substring(0, 4)
      let month = temp.substring(4)

      return {month: parseInt(month), year: year}
    },
    getBillFile(event, bill, newTab) {
      event.stopPropagation();
      event.preventDefault();

      if (bill.blob) {
        this.openFile(bill, newTab)
      }
      else {
        this.axios({
          method: "POST",
          url: this.axios.defaults.baseURL + "user/bills/file/profile/",
          responseType: "blob", // Important! Set the response type to 'blob' for binary data
          data: {
            id: bill.id,
          },
        })
          .then((resp) => {
            bill.blob = URL.createObjectURL(resp.data);

            const contentDisposition = resp.headers["content-disposition"];
            const filenameMatch = /filename=([^"]+)/.exec(contentDisposition);
            bill.filename = filenameMatch[1]

            this.openFile(bill, newTab)
          })
          .catch((e) => {
            console.log(e);
            window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
          });
      }
    },
    fetchData() {
      this.axios.get(this.axios.defaults.baseURL + "user/profile/documents/")
        .then((resp) => {
          this.documents = resp.data
        })
        .catch((e) => {
          console.log(e)
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }))
        })
    }
  },

  mounted() {
    this.fetchData()
  }
};
</script>

<style></style>
